import React from "react";
import styled from "styled-components";
import Title from "./Title";
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import { contactAnimation } from "animation";
import ImageGallery from "react-image-gallery";

import party1 from "../assets/kids/party1.jpg";
import home from "assets/oakmont/Picture1.jpg";
import { lightblue } from "./color";
function Project() {
  const [element, controls] = useScroll();

  return (
    <Section id="project" ref={element}>
      <Title value="Project" />
      <motion.div
        className="contact"
        variants={contactAnimation}
        animate={controls}
        transition={{
          delay: 0.03,
          type: "tween",
          duration: 0.8,
        }}
      >
        <div className="contact__title">
          <h2>Please note we are not </h2>
          <h3> Property Developers. </h3>
        </div>
        <div className="contact__data">
          <div className="contact__data__description">
            <p>
              We simply find good <strong className="yellow">"Flip"</strong>{" "}
              projects and pass them onto our property investor clients.
            </p>
            <p>
              You own your development property at all times and pay all
              professionals involved with development directly.
            </p>

            <p>
              If you{" "}
              <strong className="yellow">decide to take on a project</strong> we
              promote, we charge a project management fee to help you complete
              your due diligence and manage the project.
            </p>

            <p>
              Our business relies on{" "}
              <span className="yellow">repeat business.</span> Most of our
              clients try to complete two projects per year enjoying an
              exceptional income boost..
            </p>
            <br />
          </div>
        </div>
      </motion.div>
    </Section>
  );
}

const Section = styled.section`
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${home}) no-repeat center/cover;
  padding: 5rem 2rem;

.contact {
    color: var(--white-color);
    background: var(--primary-color);
    margin: 4rem auto;
    border: 2px solid ${lightblue};
    border-radius: 10px;
    min-height: auto; /* Adjust height dynamically */
    height: auto; /* Remove fixed height */
    width: 60vw;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    box-shadow: 0px 10px 20px rgba(173, 216, 230, 0.3), /* Soft blue glow */
                0px 4px 6px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */

  &__title {
    margin-bottom: 1rem;
      h2 {
        font-size: 2rem;
        color: var(--secondary-color);
      }
      h3 {
        font-size: 3rem;
        color: var(--third-color);
      }
  }
  &__data {
    gap: 2rem;
    &__description {
      // border: 1px solid green;
        margin: 0 rem;
        padding: 0rem;
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 2rem;
        text-align: left;

        p {
          font-size: 1.2rem;
        }

        .yellow {
          color: var(--third-color);
        }

        ul {
          list-style: none;
          padding: 0;
        }

        li {
          font-size: 1.5rem;
          color: var(--third-color);
          margin-bottom: 0.5rem;
        }
    }
    &__form {

      .div{
        background: var(--third-color);
        height: 300px;
      }
      }
    }
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 
  min-height: 100vh;
  .contact {
    width: 95vw;
    min-height: auto;
    height: auto;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    text-align: center;
    &__title {
      margin: 0;
      align-items:center;
      text-align: center;
      p {
        font-size: 0.8rem;
        width: 80%;
      }
      h2 {
        font-size: 1.5rem;
        text-align: center;
      }

      h3 {
        font-size: 2rem;
        text-align: center;
      }
    }
    &__data {
      max-width: 100%;
      p {
        text-align: left;
        width: 80vw;
      }
        &__description {
      padding: 0rem;
      gap: 2rem;
      margin-top: 2rem;
      h4 {
        font-size: 1rem;
        color: var(--secondary-color);
      };

      p {
        text-align: left;
        font-size: 1.1rem;
      }
      div {
        p {
          strong {
            color: var(--third-color);
            font-size: 1.1rem;
          }
        }
      }
    }

      }
    }
  }

  
}


`;

export default Project;
